import isEmpty from 'lodash/isEmpty'

import type {NewPipeline} from '../../services/pipelinesApi.types'
import type {Integration} from '../../types'

import type {PipelineDraftState, PipelineFormParams} from './EditPipelinePage.slices.types'

export function getJob(state: PipelineDraftState, id: string, jobId: string) {
  return state[id]?.draft?.settings.jobs?.[jobId]
}

export function getNextIntegrationId(draft: NewPipeline, type: string) {
  const otherIntegrationsIds: string[] =
    draft.integrations
      ?.filter(integration => integration.type === type)
      .map(integration => integration.id)
      .filter(id => id != null) ?? []

  const idNumber = Math.max(
    ...(otherIntegrationsIds
      .map(id => parseInt(id.substring(type.length + 1), 10))
      .filter(num => !isNaN(num)) ?? []),
    -1,
  )

  return `${type}_${idNumber + 1}`
}

export const filterIntegrations = (
  integrations: Integration[] | undefined,
  id: string | undefined,
  displayName: string | undefined | null,
) =>
  integrations?.filter(integration => {
    if (typeof integration === 'object') {
      return integration.id === id
    } else {
      return integration === displayName
    }
  })

export function deleteIfEmpty<T>(object: T | undefined, key: keyof T) {
  if (object != null && isEmpty(object[key])) {
    delete object[key]
    return true
  }
  return false
}

export function getPipelineFormKey({jobId, id, type}: Omit<PipelineFormParams, 'pipelineId'>) {
  return `${jobId ?? ''}_${type}_${id ?? ''}`
}
